<!-- Navbar -->
<div class="page-content settings-page">
  <div class="page-header">
    <app-navbar></app-navbar>
  </div>

  <!-- Content Section -->
  <div class="page-body" [class.collapsed]="isCollapsed" [class.open-sidebar]="openSidebar">
    <div class="sidebar" [class.collapsed]="isCollapsed">
      <app-settings-sidebar (toggleCollapse)="onToggleCollapse()" [isCollapseSidebar]="isCollapsed"
        [closeSidebar]="sidebarToggleClose.bind(this)"></app-settings-sidebar>
    </div>

    <div class="main-content" [class.collapsed]="isCollapsed">
      <router-outlet></router-outlet>
    </div>
    <div class="overlay-body" (click)="sidebarToggleClose()"></div>
  </div>
</div>